import useTranslate from 'app/i18n/useTranslate';

const useTranslation = () => {
    const t = useTranslate('fieldNameField');

    return {
        FIELD_NAME_FIELD_LABEL: t('fieldNameFieldLabel')
    };
};

export default useTranslation;
